webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(60);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueHead = __webpack_require__(38);
	
	var _vueHead2 = _interopRequireDefault(_vueHead);
	
	var _routes = __webpack_require__(5);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _store = __webpack_require__(1);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _App = __webpack_require__(39);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueHead2.default);
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  routes: _routes2.default });
	
	new _vue2.default({
	  router: router,
	  store: _store2.default,
	  el: '#app',
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(61);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  state: {
	    chapter: 1
	  },
	  mutations: {
	    changeChapter: function changeChapter(state, _ref) {
	      var n = _ref.n;
	
	      state.chapter = n;
	    }
	  },
	  actions: {
	    increment: function increment(_ref2) {
	      var commit = _ref2.commit;
	      return commit('increment');
	    }
	  }
	});

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = [
		{
			"name": "Anne et Isabelle",
			"slug": "anne_isabelle",
			"location": "France",
			"img": "anne_isabelle_famille_homoparentale.jpg",
			"video": "https://www.youtube.com/embed/YX_LGXjk1lo",
			"history1": "Anne et Isabelle vivent en couple depuis vingt ans et élèvent ensemble Aglaé, leur fille de 4 ans. Elles ont attendu 16 ans avant d’avoir leur fille, en procédant par une procréation médicalement assistée à Bruxelles.",
			"history2": "Elles ont eu leur bébé en Belgique 9 mois plus tard. A ce moment-là, la Belgique permettait aux deux membres des familles homoparentales de reconnaître le bébé, que le couple soit Belge ou d’origine d’un pays frontalier.",
			"quote1": "Parce qu'on est une famille homoparentale, nous devons être encore plus exigeantes sur l'éducation de notre fille pour ne pas recevoir de reproche.",
			"history3": "Elles sont intransigeantes avec leur fille car elles veulent éviter tout reproche envers l’éducation d’Aglaé que d’autres expliqueraient par le choix de leur orientation sexuelle.",
			"quote2": "250000 enfants vivent avec au moins un parent homosexuel en France.",
			"numbers": "Avec la loi du 17 mai 2013 sur le mariage pour tous, En 2014, les mariages de couples de même sexe ont représenté 4% du total des unions. <br> La France est devenue le 9e pays européen et le 14e pays au monde à autoriser le mariage homosexuel. Cette loi a ouvert de nouveaux droits pour le mariage, l'adoption et la succession, au nom des principes d’égalité et de partage des libertés.",
			"date1": "<b>7 novembre 2012</b> : Projet de loi.",
			"date2": "<b>23 avril 2013</b> : Adoption du projet de loi par l’ Assemblée Nationale.",
			"date3": "<b>17 mai 2013</b> : Loi ouvrant le mariage aux couples homosexuels.",
			"date4": "<b>29 mai 2013</b> : Premier mariage homosexuel à Montpellier"
		},
		{
			"name": "Emmet et Gabriel",
			"slug": "emmet_gabriel",
			"location": "Etats-Unis",
			"img": "emmet_gabriel_famille_homoparentale_usa.jpg",
			"video": "https://www.youtube.com/embed/B9x_E7Gj2qw",
			"history1": "Emmet et Gabriel, des jumeaux de 4 ans sont un cas assez typique. Ils aiment jouer dehors. Ils aiment les puzzles et les petites voitures. Et ils sont curieux de nouveaux gadgets. Ils aiment également faire des câlins à leurs parents et parfois, ils ont besoin de plus d’attention",
			"history2": "Emmet et Gabriel ont des parents assez vieux-jeu, qui se sont mariés avant d’emménager ensemble, qui ont essayé d’aller à l’église tous les dimanches, qui ont toujours voulu des enfants, qui se partagent les tâches ménagères et la vaisselle, et qui couchent leurs enfants à 20h tous les soirs. Sauf que leurs parents, Paul Melchert and James Zimmerman… sont gays.",
			"quote1": "Entendre ton fils pleurer pour la première fois à sa naissance, puis ton deuxième. C'est un moment incroyable.",
			"history3": "Les droits, les avantages et les privilèges qui viennent légalement après le mariage ne peuvent pas être obtenus d'une autre manière. Tous les bénéfices d'une famille éclorent lorsque l'on sait que sa famille est en sécurité. C'est pour cela que nous souhaitions véritablement nous marier.",
			"quote2": "Entre 8 et 10 millions d’enfants seraient élevés sur le sol américain au sein de familles homoparentales.",
			"numbers": "Barack Obama, a affirmé durant sa campagne électorale de 2008 que les couples homosexuels méritaient les mêmes droits que les autres couples et se déclarait favorable aux unions civiles homosexuelles mais pas au mariage homosexuel. Il affirma en 2010 que sa position évoluait « constamment » sur ce sujet.",
			"date1": "17 mai 2004 : Le Massachussetts adopte la loi permettant le mariage homosexuel. <br> C’est le premier état des états-unis à l’autoriser ",
			"date2": "15 mai 2008 : les habitants de l’état de Californie votent pour le mariage de personnes du même sexe.<br> Ce vote entraîne les autres états à considérer la question.",
			"date3": "1er janvier 2014 : 23 états autorisent le mariage gay",
			"date4": "26 juin : arrêt rendu par la Cour Suprême des Etats-Unis, légalisant le mariage gay dans tous les Etats-Unis"
		},
		{
			"name": "Christina et Karina",
			"slug": "christina_karina",
			"location": "Suède",
			"img": "christina_karina_famille_homoparentale_suede.jpg",
			"video": "https://www.youtube.com/embed/erGytWbqF78",
			"history1": "C'est un prof de fitness aux Etats-Unis qui donna à ce couple gay l'idée de congeler les ovules de Karina. Bien que ce processus soit facile, il est illégal en Suède pour une personne de porter les ovules de sa partenaire - ce que ces deux femmes souhaitaient pourtant faire.",
			"history2": "Voyageant aux Etats-Unis, leur première procréation médicalement assistée a donné naissance à leur fille, Bonnie. Depuis deux ans, elles essayent de nouveau de donner naissance à un frère ou une soeur pour Bonnie.",
			"quote1": "Lorsque l'on veut un enfant, nous devons être particulièrement prêts dans ce type de famille. Nous n'avons pas le droit à l'erreur.",
			"history3": "Nous allons essayer une dernière fois de faire un enfant, mais bien que nous soyons très motivées, financièrement c'est difficile de faire les allers-retours aux Etats-Unis.",
			"quote2": "Depuis 2009, un seul couple homosexuel a pu adopter un enfant en Suède.",
			"numbers": "La Suède a créé en 1995 un partenariat pour les couples homosexuels sur le modèle danois. Après la publication, en 2001, d'un rapport du ministère de la justice montrant que l'intérêt de l'enfant est aussi bien respecté dans les familles homoparentales que dans les autres, la Suède a légalisé l'homoparentalité : elle a ouvert aux homosexuels l'adoption conjointe en 2003 et la procréation médicalement assistée en 2005. En 2009, le mariage a été autorisé pour les couples de même sexe.",
			"date1": "1er avril 2009 : le mariage entre personnes du même sexe est autorisé.",
			"date2": "1er mai 2009 : la loi entre en vigueur.",
			"date3": "1er novembre 2009 : Le mariage religieux est autorisé pour les homosexuels. <br> Si la Suède n'est pas le premier pays à légaliser le mariage homosexuel, c'est le premier à inclure dans la législation l'interdiction de refus du mariage religieux pour les homosexuels."
		},
		{
			"name": "John et Anthony",
			"slug": "john_anthony",
			"location": "Pays-Bas",
			"img": "john_anthony_famille_homoparentale_pays_bas.jpg",
			"video": "https://www.youtube.com/embed/0EPr91ZANgA",
			"history1": "John a toujours voulu être père. Mais en tant qu'homme homosexuel avec une vie professionnelle très occupée, il a fini par se résoudre à abandonner ses rêves.",
			"history2": "Plus tard, il rencontre Anthony, leur relation a beaucoup évolué en 7 ans. Ils se sont dit que beaucoup d'enfants grandissaient avec un maman et un papa, sans pour autant avoir une enfance incroyable. Donc pourquoi ne pas avoir nous aussi ce privilège d'élever des enfants puisque nous savons que nous allons tout faire pour bien les élever, les aimer, et les protéger.",
			"quote1": "C'est une sacrée femme pour faire ce qu'elle a fait, porter nos bébés et nous les donner de ses mains ",
			"history3": "Depuis que nous avons des enfants, c'est comme si nous pouvions respirer pour la première fois de notre vie. Nous n'aurions jamais imaginé avoir des enfants. C'est la plus belle chose qui nous est arrivée dans notre vie.",
			"quote2": "20% des 55 000 couples homosexuels des Pays-Bas se sont mariés entre 2001 et 2011.",
			"numbers": "Les Pays-Bas sont le premier pays au monde à reconnaître le mariage homosexuel.",
			"date1": "21 décembre 2000 : la loi pour le mariage homosexuel est votée.",
			"date2": "1er avril 2011 : date d'entrée en vigueur de la loi autorisant le mariage homosexuel."
		},
		{
			"name": "Lisa et Melissa",
			"slug": "lisa_melissa",
			"location": "Canada",
			"img": "lisa_melissa_famille_homoparentale_canada.jpg",
			"video": "https://www.youtube.com/embed/evaY0VaE9_A",
			"history1": "Elles sont allées à la même université. Mais Lisa était pompom girl et Mélissa une joueuse de basket, donc elles ne se sont jamais vraiment parlées. C'était 15 années plus tard que Mélissa posta une photo sur Instagram qui a tout de suite capté l'attention de Lisa. Elle a désormais les cheveux courts, et après une série de textos, elles se sont données rendez-vous.",
			"history2": "Après deux ans de relation, la question d'avoir un enfant émerge naturellement.",
			"quote1": "La maladie de Lisa nous a poussé à accélérer le processus avant que la chimiothérapie n'ait commencé.",
			"history3": "Elles avaient déjà trouvé leur donneur de sperme lorsqu'elles ont appris la mauvaise nouvelle : Lisa fut diagnostiquée d'un cancer du sein en phase 3. En dépit de ce choc, elles ont rapidement pris la décision de congeler ses oeufs avant la chimiothérapie. Et maintenant, avec joie et santé, elles sont prêtes à construire une famille ensemble.",
			"quote2": "Au québec, près de 1 400 enfants vivent dans une famille homoparentale.",
			"numbers": "Aujourd'hui, un couple sur trois qui demande à adopter un enfant à Montréal est homosexuel. La grande majorité des candidats sont gays. Les lesbiennes, elles, peuvent recourir à l'insémination artificielle, gratuite au Québec depuis 2010.",
			"date1": "2003 : Neuf des treize états du Canada autorisent le mariage aux conjoints de même sexe.",
			"date2": "20 juillet 2006 : adoption de la loi sur le mariage civil rendant légal le mariage gay dans tous les états."
		},
		{
			"name": "Tess et Nikina",
			"slug": "tess_nikina",
			"location": "Royaume-Uni",
			"img": "tess_nikina_famille_homoparentale_canada.jpg",
			"video": "https://www.youtube.com/embed/CQzTl10ciMk",
			"history1": "Quand Tess et Niki ont décidé d'agrandir leur famille, elles ont pensé à se reprodruire biologiquement ou d'avoir recours à l'adoption. Cette dernière les a conduit à attendre un an avant de pouvoir adopoter légalement leurs enfants, Jaida et Quentin. ",
			"history2": "Mais toutes les difficultés se sont envolées lorsqu'elles sont officiellement devenues une famille, avec le même nom de famille.",
			"quote1": "A l'hopital, devant Kévin nous étions ''Oh, un petit bébé blanc! Oh ça va aller, ça va être formidable.''",
			"history3": "Bien qu'elles aient l'air de femmes tout à fait conventionnelles de multiples façons, leur ouverture d'esprit, leur confiance en elles et l'amour inconditionnel qu'elles ont pour leurs enfants, les aident à marquer la petite ville où elles habitent en Angleterre.",
			"quote2": "60 enfants sont adoptés par des familles homoparentales chaque année, au Royaume-Uni.",
			"numbers": "En 2015, le Royaume-Uni enregistre le plus grand nombre d'adoptions par des familles homoparentales, 480 enfants ont ainsi été adoptés.",
			"date1": "Fin 2012 : Cameron est le premier personnage politique à abordé la question du mariage gay.",
			"date2": "5 février 2013 : le mariage gay religieux est accepté en seconde lecture4 à la Chambre des communes, mais n'équivaut pas à une loi adoptée.",
			"date3": "29 mars 2014 : les mariages homosexuels sont possibles"
		}
	];

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(22)
	
	/* script */
	__vue_exports__ = __webpack_require__(7)
	
	/* template */
	var __vue_template__ = __webpack_require__(54)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-67efae1d"
	
	module.exports = __vue_exports__


/***/ },
/* 4 */,
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Homepage = __webpack_require__(45);
	
	var _Homepage2 = _interopRequireDefault(_Homepage);
	
	var _Experience = __webpack_require__(44);
	
	var _Experience2 = _interopRequireDefault(_Experience);
	
	var _Reveal = __webpack_require__(46);
	
	var _Reveal2 = _interopRequireDefault(_Reveal);
	
	var _Credits = __webpack_require__(43);
	
	var _Credits2 = _interopRequireDefault(_Credits);
	
	var _Testimonials = __webpack_require__(48);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	var _Testimonial = __webpack_require__(47);
	
	var _Testimonial2 = _interopRequireDefault(_Testimonial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = [{ path: '/', component: _Homepage2.default }, { path: '/experience', component: _Experience2.default }, { path: '/reveal', component: _Reveal2.default }, {
	  path: '/testimonials',
	  component: _Testimonials2.default
	}, { path: '/testimonials/:id', component: _Testimonial2.default }, { path: '/credits', component: _Credits2.default }];
	
	exports.default = routes;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavBar = __webpack_require__(40);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    NavBar: _NavBar2.default
	  }
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'card',
	  props: ['img', 'title', 'subtitle'],
	  computed: {
	    imagePath: function imagePath() {
	      return __webpack_require__(62)("./" + this.img);
	    }
	  }
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'nav-bar'
	};

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'social',
	  props: ['link']
	};

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'timeline',
	  props: ['length', 'count', 'age'],
	  data: function data() {
	    return {
	      tempAge: '3 mois'
	    };
	  },
	  methods: {
	    changeChapter: function changeChapter(n) {
	      this.$store.commit('changeChapter', { n: n });
	    }
	  }
	};

/***/ },
/* 11 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'credits',
	  head: {
	    title: {
	      inner: 'Crédits'
	    }
	  }
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Timeline = __webpack_require__(42);
	
	var _Timeline2 = _interopRequireDefault(_Timeline);
	
	var _chapters = __webpack_require__(28);
	
	var _chapters2 = _interopRequireDefault(_chapters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'experience',
	  head: {
	    title: {
	      inner: 'Experience'
	    }
	  },
	  data: function data() {
	    return {
	      chapters: _chapters2.default,
	      grabbing: false,
	      grabbed: false,
	      mouse: {
	        start: { x: 0, y: 0 },
	        current: { x: 0, y: 0 }
	      },
	      angle: 0,
	      dragShow: false,
	      circleContainerWidth: 32,
	      dragRange: {
	        from: 0,
	        to: 0
	      }
	    };
	  },
	  computed: {
	    mouseOffsetX: function mouseOffsetX() {
	      return this.mouse.current.x - this.mouse.start.x;
	    },
	    mouseOffsetY: function mouseOffsetY() {
	      return this.mouse.current.y - this.mouse.start.y;
	    },
	    onTarget: function onTarget() {
	      if (this.angle < Math.PI / 2 - 3) {
	        return true;
	      }
	      return false;
	    },
	    chapter: function chapter() {
	      return this.$store.state.chapter;
	    }
	  },
	  components: {
	    Timeline: _Timeline2.default
	  },
	  watch: {
	    angle: function angle() {
	      if (this.grabbing) {
	        this.scratchVideo(this.dragRange.from + -2 * this.angle * (this.dragRange.to - this.dragRange.from) / Math.PI);
	      }
	      if (this.angle > 0) {
	        this.angle = 0;
	      }
	    },
	    grabbing: function grabbing() {
	      if (this.grabbing) {
	        this.video.removeEventListener('timeupdate', this.ontimeupdate);
	      } else {
	        this.video.addEventListener('timeupdate', this.ontimeupdate);
	      }
	    }
	  },
	  methods: {
	    pauseVideo: function pauseVideo() {
	      this.video.pause();
	    },
	    playVideo: function playVideo() {
	      this.video.play();
	    },
	    grab: function grab(e) {
	      if (this.grabbed === false) {
	        if (e.clientX || e.clientY) {
	          this.mouse.start.x = e.clientX;
	          this.mouse.start.y = e.clientY;
	        } else {
	          this.mouse.start.y = e.changedTouches[0].pageY;
	          this.mouse.start.x = e.changedTouches[0].pageX;
	        }
	      }
	      this.grabbing = true;
	
	      this.grabbed = true;
	
	      this.$el.addEventListener('mousemove', this.changeMouseInfos);
	      this.$el.addEventListener('touchmove', this.changeMouseInfos);
	
	      this.$el.addEventListener('mouseup', this.ungrab);
	      this.$el.addEventListener('mouseleave', this.ungrab);
	      this.$el.addEventListener('touchend', this.ungrab);
	    },
	    ungrab: function ungrab() {
	      this.$el.removeEventListener('mousemove', this.changeMouseInfos);
	      this.$el.removeEventListener('touchmove', this.changeMouseInfos);
	      this.grabbing = false;
	
	      if (this.onTarget) {
	        this.playVideo();
	        this.resetDrag();
	      }
	    },
	    changeMouseInfos: function changeMouseInfos(e) {
	      if (isNaN(Math.asin(this.mouseOffsetY / this.circleContainerWidth))) {
	        this.angle = -(Math.PI / 2);
	      } else {
	        this.angle = Math.asin(this.mouseOffsetY / this.circleContainerWidth);
	      }
	
	      if (e.clientY || e.clientX) {
	        this.mouse.current.y = e.clientY;
	        this.mouse.current.x = e.clientX;
	      } else {
	        this.mouse.current.y = e.changedTouches[0].pageY;
	        this.mouse.current.x = e.changedTouches[0].pageX;
	      }
	    },
	    changeChapter: function changeChapter(chapter) {
	      this.$store.commit('changeChapter', { n: chapter });
	    },
	    scratchVideo: function scratchVideo(at) {
	      var _this = this;
	
	      if (this.video.play()) {
	        this.video.play().then(function () {
	          _this.video.currentTime = at;
	          _this.video.pause();
	        });
	      } else {
	        this.video.currentTime = at;
	      }
	    },
	    resetDrag: function resetDrag() {
	      this.dragged = false;
	      this.angle = 0;
	      this.mouse.current.x = 0;
	      this.mouse.current.y = 0;
	      this.dragShow = false;
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.video = this.$el.querySelector('video');
	    var video = this.video;
	    this.ontimeupdate = function () {
	      _chapters2.default.forEach(function (chapter, index) {
	        if (Math.floor(video.currentTime) === chapter.from) {
	          _this2.pauseVideo();
	          _this2.dragRange.from = chapter.from;
	          _this2.dragRange.to = chapter.to;
	          _this2.dragShow = true;
	        }
	
	        if (Math.floor(video.currentTime) === chapter.time) {
	          _this2.changeChapter(index + 1);
	        }
	      });
	    };
	
	    video.addEventListener('timeupdate', this.ontimeupdate);
	
	    video.onended = function () {
	      _this2.$router.push('/reveal');
	    };
	
	    this.circleContainerWidth = this.$el.querySelector('.circleContainer').offsetWidth;
	  }
	};

/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Homepage',
	  head: {
	    title: {
	      inner: 'Home'
	    }
	  }
	};

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Reveal',
	  head: {
	    title: {
	      inner: 'Reveal'
	    }
	  }
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _couples = __webpack_require__(2);
	
	var _couples2 = _interopRequireDefault(_couples);
	
	var _Card = __webpack_require__(3);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Social = __webpack_require__(41);
	
	var _Social2 = _interopRequireDefault(_Social);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'testimonial',
	  head: {
	    title: {
	      inner: 'Testimonial'
	    }
	  },
	  components: {
	    Card: _Card2.default,
	    Social: _Social2.default
	  },
	  data: function data() {
	    return {
	      index: 0,
	      couple: {},
	      similars: []
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.index = _couples2.default.findIndex(function (item) {
	      return item.slug === _this.$route.params.id;
	    });
	    this.couple = _couples2.default[this.index];
	    for (var i = 1; i < 4; i += 1) {
	      this.similars.push(_couples2.default[(this.index + i) % _couples2.default.length]);
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    var similar = document.querySelectorAll('.similars a');
	    for (var i = 0; i < similar.length; i++) {
	      similar[i].addEventListener('click', function () {
	        _this2.index = _couples2.default.findIndex(function (item) {
	          return item.slug === _this2.$route.params.id;
	        });
	        _this2.couple = _couples2.default[_this2.index];
	        document.body.scrollTop = 0;
	        document.documentElement.scrollTop = 0;
	      });
	    }
	  }
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(1);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Card = __webpack_require__(3);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _couples = __webpack_require__(2);
	
	var _couples2 = _interopRequireDefault(_couples);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'testimonials',
	  store: _store2.default,
	  head: {
	    title: {
	      inner: 'Testimonials'
	    }
	  },
	  components: {
	    Card: _Card2.default
	  },
	  data: function data() {
	    return {
	      couples: _couples2.default
	    };
	  }
	};

/***/ },
/* 17 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 18 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 19 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 20 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 21 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 22 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 23 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 24 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 25 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 26 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 27 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports = [
		{
			"title": "8 mois",
			"time": 0,
			"from": 12,
			"to": 17
		},
		{
			"title": "9 mois",
			"time": 28,
			"from": 30,
			"to": 37
		},
		{
			"title": "3 ans",
			"time": 44,
			"from": 48,
			"to": 50
		},
		{
			"title": "4 ans",
			"time": 54,
			"from": 72,
			"to": 74
		},
		{
			"title": "6 ans",
			"time": 90,
			"from": 105,
			"to": 111
		},
		{
			"title": "7 ans",
			"time": 118,
			"from": 119,
			"to": 126
		}
	];

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/anne_isabelle_famille_homoparentale.4461aa4.jpg";

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/christina_karina_famille_homoparentale_suede.bb736c8.jpg";

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/emmet_gabriel_famille_homoparentale_usa.34a70b0.jpg";

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/homepage_cover.1149227.png";

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/john_anthony_famille_homoparentale_pays_bas.db9a9b2.jpg";

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/lisa_melissa_famille_homoparentale_canada.32cdc2f.jpg";

/***/ },
/* 35 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/paul_henri.26e7e14.png";

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/tess_nikina_famille_homoparentale_canada.ff36787.jpg";

/***/ },
/* 38 */,
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(26)
	
	/* script */
	__vue_exports__ = __webpack_require__(6)
	
	/* template */
	var __vue_template__ = __webpack_require__(58)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(25)
	
	/* script */
	__vue_exports__ = __webpack_require__(8)
	
	/* template */
	var __vue_template__ = __webpack_require__(57)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ccf7c486"
	
	module.exports = __vue_exports__


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(21)
	
	/* script */
	__vue_exports__ = __webpack_require__(9)
	
	/* template */
	var __vue_template__ = __webpack_require__(53)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-588cea8c"
	
	module.exports = __vue_exports__


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(20)
	
	/* script */
	__vue_exports__ = __webpack_require__(10)
	
	/* template */
	var __vue_template__ = __webpack_require__(52)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-58767764"
	
	module.exports = __vue_exports__


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(23)
	
	/* script */
	__vue_exports__ = __webpack_require__(11)
	
	/* template */
	var __vue_template__ = __webpack_require__(55)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-740254c3"
	
	module.exports = __vue_exports__


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(17)
	
	/* script */
	__vue_exports__ = __webpack_require__(12)
	
	/* template */
	var __vue_template__ = __webpack_require__(49)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-011826d1"
	
	module.exports = __vue_exports__


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(27)
	
	/* script */
	__vue_exports__ = __webpack_require__(13)
	
	/* template */
	var __vue_template__ = __webpack_require__(59)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f9bf39d6"
	
	module.exports = __vue_exports__


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(18)
	
	/* script */
	__vue_exports__ = __webpack_require__(14)
	
	/* template */
	var __vue_template__ = __webpack_require__(50)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2bcb0b34"
	
	module.exports = __vue_exports__


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(24)
	
	/* script */
	__vue_exports__ = __webpack_require__(15)
	
	/* template */
	var __vue_template__ = __webpack_require__(56)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7ae689c8"
	
	module.exports = __vue_exports__


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(19)
	
	/* script */
	__vue_exports__ = __webpack_require__(16)
	
	/* template */
	var __vue_template__ = __webpack_require__(51)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-34d35f4a"
	
	module.exports = __vue_exports__


/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "experience"
	  }, [_h('video', {
	    staticClass: "video",
	    attrs: {
	      "src": "http://adrienmenegaux.com/video/experience_video.mp4",
	      "muted": "",
	      "autoplay": ""
	    }
	  }), " ", _h('audio', {
	    attrs: {
	      "src": "http://adrienmenegaux.com/sound/castle_in_the_sky_theme_%20joe_hisaishi.mp3",
	      "autoplay": "",
	      "loop": ""
	    }
	  }), " ", _h('div', {
	    staticClass: "circleContainer",
	    style: ({
	      opacity: _vm.dragShow ? 1 : 0
	    })
	  }, [_h('div', {
	    staticClass: "landingZone",
	    class: {
	      grow: _vm.onTarget
	    }
	  }), " ", _h('svg', {
	    staticClass: "rail",
	    attrs: {
	      "viewBox": "0 0 100 100",
	      "preserveAspectRatio": "none"
	    }
	  }, [_h('path', {
	    attrs: {
	      "d": "m0 0 c 50 0, 100 50, 100 100"
	    }
	  })]), " ", _h('div', {
	    staticClass: "circle",
	    class: {
	      grabbing: _vm.grabbing
	    },
	    style: ({
	      transform: 'rotate(' + _vm.angle + 'rad)'
	    }),
	    on: {
	      "mousedown": _vm.grab,
	      "touchstart": _vm.grab
	    }
	  })]), " ", _h('Timeline', {
	    staticClass: "timeline",
	    attrs: {
	      "length": _vm.chapters.length,
	      "count": _vm.$store.state.chapter,
	      "age": _vm.chapters[_vm.$store.state.chapter - 1].title
	    }
	  })])
	},staticRenderFns: []}

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "reveal"
	  }, [_h('h1', {
	    staticClass: "reveal-final"
	  }, ["Une mère n’est pas forcément une femme."]), " ", _vm._m(0), " ", _h('p', {
	    staticClass: "reveal-partage"
	  }, ["Elle vous a plu ? Partagez là !"]), " ", _h('div', {
	    staticClass: "social"
	  }, [_h('a', {
	    staticClass: "resp-sharing-button__link",
	    attrs: {
	      "href": "https://facebook.com/sharer/sharer.php?u=http%3A%2F%2Fadrienmenegaux.com%2F",
	      "target": "_blank",
	      "aria-label": ""
	    }
	  }, [_h('div', {
	    staticClass: "resp-sharing-button resp-sharing-button--facebook resp-sharing-button--small"
	  }, [_h('div', {
	    staticClass: "resp-sharing-button__icon resp-sharing-button__icon--solid",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_h('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_h('path', {
	    attrs: {
	      "d": "M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z"
	    }
	  })])])])]), " ", " ", _h('a', {
	    staticClass: "resp-sharing-button__link",
	    attrs: {
	      "href": "https://twitter.com/intent/tweet/?text=Magna%20Mater&url=http%3A%2F%2Fadrienmenegaux.com%2F",
	      "target": "_blank",
	      "aria-label": ""
	    }
	  }, [_h('div', {
	    staticClass: "resp-sharing-button resp-sharing-button--twitter resp-sharing-button--small"
	  }, [_h('div', {
	    staticClass: "resp-sharing-button__icon resp-sharing-button__icon--solid",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_h('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_h('path', {
	    attrs: {
	      "d": "M23.44 4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96 1.32-2.02-.88.52-1.86.9-2.9 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.55 2.04-4.55 4.54 0 .36.03.7.1 1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6 1.45-.6 2.3 0 1.56.8 2.95 2 3.77-.74-.03-1.44-.23-2.05-.57v.06c0 2.2 1.56 4.03 3.64 4.44-.67.2-1.37.2-2.06.08.58 1.8 2.26 3.12 4.25 3.16C5.78 18.1 3.37 18.74 1 18.46c2 1.3 4.4 2.04 6.97 2.04 8.35 0 12.92-6.92 12.92-12.93 0-.2 0-.4-.02-.6.9-.63 1.96-1.22 2.56-2.14z"
	    }
	  })])])])]), " ", " ", _h('a', {
	    staticClass: "resp-sharing-button__link",
	    attrs: {
	      "href": "mailto:?subject=Magna%20Mater&body=http%3A%2F%2Fadrienmenegaux.com%2F",
	      "target": "_self",
	      "aria-label": ""
	    }
	  }, [_h('div', {
	    staticClass: "resp-sharing-button resp-sharing-button--email resp-sharing-button--small"
	  }, [_h('div', {
	    staticClass: "resp-sharing-button__icon resp-sharing-button__icon--solid",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_h('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_h('path', {
	    attrs: {
	      "d": "M22 4H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.25 14.43l-3.5 2c-.08.05-.17.07-.25.07-.17 0-.34-.1-.43-.25-.14-.24-.06-.55.18-.68l3.5-2c.24-.14.55-.06.68.18.14.24.06.55-.18.68zm4.75.07c-.1 0-.2-.03-.27-.08l-8.5-5.5c-.23-.15-.3-.46-.15-.7.15-.22.46-.3.7-.14L12 13.4l8.23-5.32c.23-.15.54-.08.7.15.14.23.07.54-.16.7l-8.5 5.5c-.08.04-.17.07-.27.07zm8.93 1.75c-.1.16-.26.25-.43.25-.08 0-.17-.02-.25-.07l-3.5-2c-.24-.13-.32-.44-.18-.68s.44-.32.68-.18l3.5 2c.24.13.32.44.18.68z"
	    }
	  })])])])])]), " ", _h('div', {
	    staticClass: "reveal-bar"
	  }), " ", _h('router-link', {
	    staticClass: "link",
	    attrs: {
	      "to": "/testimonials"
	    }
	  }, [_h('div', {
	    staticClass: "btn"
	  }, [_h('div', {
	    staticClass: "btn-text"
	  }, ["Découvrir les témoignages"])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('h2', {
	    staticClass: "reveal-second"
	  }, ["Lors de cette expérience, vous avez incarné un membre d'un couple homoparental.", _h('br'), "Le plus important aux yeux de l'enfant est l'amour que ses parents lui apportent."])
	}]}

/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_h('div', {
	    staticClass: "homepage"
	  }, [_h('h1', ["DÉCOUVREZ LES TÉMOIGNAGES DE COUPLES HOMOPARENTAUX"]), " ", _h('div', {
	    staticClass: "couples"
	  }, [_vm._l((_vm.couples), function(couple) {
	    return _h('router-link', {
	      staticClass: "link",
	      attrs: {
	        "to": '/testimonials/' + couple.slug
	      }
	    }, [_h('Card', {
	      staticClass: "couple",
	      attrs: {
	        "title": couple.name,
	        "subtitle": couple.location,
	        "img": couple.img
	      }
	    })])
	  })])])])
	},staticRenderFns: []}

/***/ },
/* 52 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "timeline"
	  }, [_h('h3', ["\n    Votre enfant a:", _h('br'), " ", _h('strong', [_vm._s(_vm.age)])]), " ", _h('div', {
	    staticClass: "bars"
	  }, [_vm._l((_vm.length), function(n) {
	    return _h('div', {
	      staticClass: "bar"
	    }, [_h('div', {
	      staticClass: "line",
	      class: [n > _vm.count ? '' : 'active']
	    })])
	  })]), " ", _h('router-link', {
	    staticClass: "link",
	    attrs: {
	      "to": "/reveal"
	    }
	  }, [_h('h3', ["PASSER", _h('br'), "L'EXPERIENCE"])])])
	},staticRenderFns: []}

/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "social"
	  }, [_h('a', {
	    staticClass: "resp-sharing-button__link",
	    attrs: {
	      "href": "https://facebook.com/sharer/sharer.php?u=http%3A%2F%2Fadrienmenegaux.com%2F",
	      "target": "_blank",
	      "aria-label": ""
	    }
	  }, [_h('div', {
	    staticClass: "resp-sharing-button resp-sharing-button--facebook resp-sharing-button--small"
	  }, [_h('div', {
	    staticClass: "resp-sharing-button__icon resp-sharing-button__icon--solid",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_h('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_h('path', {
	    attrs: {
	      "d": "M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z"
	    }
	  })])])])]), " ", " ", _h('a', {
	    staticClass: "resp-sharing-button__link",
	    attrs: {
	      "href": "https://twitter.com/intent/tweet/?text=Magna%20Mater&url=http%3A%2F%2Fadrienmenegaux.com%2F",
	      "target": "_blank",
	      "aria-label": ""
	    }
	  }, [_h('div', {
	    staticClass: "resp-sharing-button resp-sharing-button--twitter resp-sharing-button--small"
	  }, [_h('div', {
	    staticClass: "resp-sharing-button__icon resp-sharing-button__icon--solid",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_h('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_h('path', {
	    attrs: {
	      "d": "M23.44 4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96 1.32-2.02-.88.52-1.86.9-2.9 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.55 2.04-4.55 4.54 0 .36.03.7.1 1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6 1.45-.6 2.3 0 1.56.8 2.95 2 3.77-.74-.03-1.44-.23-2.05-.57v.06c0 2.2 1.56 4.03 3.64 4.44-.67.2-1.37.2-2.06.08.58 1.8 2.26 3.12 4.25 3.16C5.78 18.1 3.37 18.74 1 18.46c2 1.3 4.4 2.04 6.97 2.04 8.35 0 12.92-6.92 12.92-12.93 0-.2 0-.4-.02-.6.9-.63 1.96-1.22 2.56-2.14z"
	    }
	  })])])])]), " ", " ", _h('a', {
	    staticClass: "resp-sharing-button__link",
	    attrs: {
	      "href": "mailto:?subject=Magna%20Mater&body=http%3A%2F%2Fadrienmenegaux.com%2F",
	      "target": "_self",
	      "aria-label": ""
	    }
	  }, [_h('div', {
	    staticClass: "resp-sharing-button resp-sharing-button--email resp-sharing-button--small"
	  }, [_h('div', {
	    staticClass: "resp-sharing-button__icon resp-sharing-button__icon--solid",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_h('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_h('path', {
	    attrs: {
	      "d": "M22 4H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.25 14.43l-3.5 2c-.08.05-.17.07-.25.07-.17 0-.34-.1-.43-.25-.14-.24-.06-.55.18-.68l3.5-2c.24-.14.55-.06.68.18.14.24.06.55-.18.68zm4.75.07c-.1 0-.2-.03-.27-.08l-8.5-5.5c-.23-.15-.3-.46-.15-.7.15-.22.46-.3.7-.14L12 13.4l8.23-5.32c.23-.15.54-.08.7.15.14.23.07.54-.16.7l-8.5 5.5c-.08.04-.17.07-.27.07zm8.93 1.75c-.1.16-.26.25-.43.25-.08 0-.17-.02-.25-.07l-3.5-2c-.24-.13-.32-.44-.18-.68s.44-.32.68-.18l3.5 2c.24.13.32.44.18.68z"
	    }
	  })])])])])])
	},staticRenderFns: []}

/***/ },
/* 54 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('article', {
	    staticClass: "container"
	  }, [_h('div', {
	    staticClass: "cover",
	    style: ({
	      backgroundImage: 'url(' + _vm.imagePath + ')'
	    }),
	    attrs: {
	      "alt": _vm.title
	    }
	  }), " ", _h('div', {
	    staticClass: "description"
	  }, [_h('div', {
	    staticClass: "title"
	  }, [_vm._s(_vm.title)]), " ", _h('div', {
	    staticClass: "subtitle"
	  }, [_vm._s(_vm.subtitle)])])])
	},staticRenderFns: []}

/***/ },
/* 55 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "credits"
	  }, [_h('div', {
	    staticClass: "credits__bar"
	  }, [_h('div', {
	    staticClass: "credits__bar-text"
	  }, ["crédits et ", _h('div', ["remerciements"])])]), " ", _h('div', {
	    staticClass: "credits__content"
	  }, [_h('div', {
	    staticClass: "credits__content-title"
	  }, ["remerciements"]), " ", _h('div', {
	    staticClass: "credits__content-text"
	  }, ["Nous tenons à remercier en premier lieu les parents qui nous ont permis de filmer leurs enfants dans le cadre de notre projet. Un grand merci à M. Pumir et son fils Balthazar, Mme Boudisseau et son fils Jean, et à Mme Gossioux et son fils Gabriel."]), " ", _h('div', {
	    staticClass: "credits__content-title"
	  }, ["crédits audio"]), " ", _h('div', {
	    staticClass: "credits__content-text"
	  }, ["Joe Hisaishi - Castle in the Sky Theme utilisé dans le cadre de l’expérience vidéo."]), " ", _h('div', {
	    staticClass: "credits__content-title"
	  }, ["crédits vidéo"]), " ", _h('div', {
	    staticClass: "credits__content-text"
	  }, ["Les témoignages vidéos utilisés dans les pages « Témoignages » proviennent de l’association Love Comes First. L’utilisation de ces vidéos est uniquement destinée à un cadre de projet scolaire. Ces témoignages ne sont en aucun cas utilisés à des fins commerciales."])])])
	}]}

/***/ },
/* 56 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "testimonial"
	  }, [_h('div', {
	    staticClass: "video-overlay"
	  }, [_h('div', {
	    staticClass: "testimonial-title testimonial-infos"
	  }, ["Témoignage"]), " ", _h('div', {
	    staticClass: "testimonial-infos"
	  }, [_vm._s(_vm.couple.name)]), " ", _h('div', {
	    staticClass: "testimonial-infos"
	  }, [_vm._s(_vm.couple.location)])]), " ", _h('iframe', {
	    attrs: {
	      "width": "560",
	      "height": "315",
	      "src": _vm.couple.video + '?showinfo=0&iv_load_policy=3&controls=0',
	      "frameborder": "0",
	      "allowfullscreen": ""
	    }
	  }), " ", _h('div', {
	    staticClass: "testimonal__content"
	  }, [_h('div', {
	    staticClass: "testimonial__text"
	  }, [_h('div', {
	    staticClass: "testimonial-subtitle testimonial-subtitle-special"
	  }, ["Leur histoire"]), " ", _h('p', {
	    staticClass: "paragraphe"
	  }, [_vm._s(_vm.couple.history1)]), " ", _h('p', {
	    staticClass: "paragraphe"
	  }, [_vm._s(_vm.couple.history2)]), " ", _h('div', {
	    staticClass: "quote"
	  }, [_h('div', {
	    staticClass: "quote-bar"
	  }), " ", _h('div', {
	    staticClass: "quote-text"
	  }, [_vm._s(_vm.couple.quote1)])]), " ", _h('p', {
	    staticClass: "paragraphe"
	  }, [_vm._s(_vm.couple.history3)])]), " ", _h('div', {
	    staticClass: "testimonial-bar"
	  }, [_h('div', {
	    staticClass: "testimonial-infos testimonial-bar-text"
	  }, ["L'homoparentalité ", _h('div', ["en " + _vm._s(_vm.couple.location)])])]), " ", _h('div', {
	    staticClass: "testimonial__text"
	  }, [_h('div', {
	    staticClass: "testimonial-subtitle"
	  }, ["Les chiffres"]), " ", _h('div', {
	    staticClass: "quote quote-special"
	  }, [_h('div', {
	    staticClass: "quote-bar"
	  }), " ", _h('div', {
	    staticClass: "quote-text"
	  }, [_vm._s(_vm.couple.quote2)])]), " ", _h('p', {
	    staticClass: "paragraphe",
	    domProps: {
	      "innerHTML": _vm._s(_vm.couple.numbers)
	    }
	  }), " ", _h('div', {
	    staticClass: "testimonial-subtitle"
	  }, ["Les lois"]), " ", _h('p', {
	    staticClass: "paragraphe",
	    domProps: {
	      "innerHTML": _vm._s(_vm.couple.date1)
	    }
	  }), " ", _h('p', {
	    staticClass: "paragraphe",
	    domProps: {
	      "innerHTML": _vm._s(_vm.couple.date2)
	    }
	  }), " ", _h('p', {
	    staticClass: "paragraphe",
	    domProps: {
	      "innerHTML": _vm._s(_vm.couple.date3)
	    }
	  }), " ", _h('p', {
	    staticClass: "paragraphe",
	    domProps: {
	      "innerHTML": _vm._s(_vm.couple.date4)
	    }
	  }), " ", _h('div', {
	    staticClass: "social"
	  }, [_h('a', {
	    staticClass: "resp-sharing-button__link",
	    attrs: {
	      "href": "https://facebook.com/sharer/sharer.php?u=http%3A%2F%2Fadrienmenegaux.com%2F",
	      "target": "_blank",
	      "aria-label": ""
	    }
	  }, [_h('div', {
	    staticClass: "resp-sharing-button resp-sharing-button--facebook resp-sharing-button--small"
	  }, [_h('div', {
	    staticClass: "resp-sharing-button__icon resp-sharing-button__icon--solid",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_h('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_h('path', {
	    attrs: {
	      "d": "M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z"
	    }
	  })])])])]), " ", " ", _h('a', {
	    staticClass: "resp-sharing-button__link",
	    attrs: {
	      "href": "https://twitter.com/intent/tweet/?text=Magna%20Mater&url=http%3A%2F%2Fadrienmenegaux.com%2F",
	      "target": "_blank",
	      "aria-label": ""
	    }
	  }, [_h('div', {
	    staticClass: "resp-sharing-button resp-sharing-button--twitter resp-sharing-button--small"
	  }, [_h('div', {
	    staticClass: "resp-sharing-button__icon resp-sharing-button__icon--solid",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_h('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_h('path', {
	    attrs: {
	      "d": "M23.44 4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96 1.32-2.02-.88.52-1.86.9-2.9 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.55 2.04-4.55 4.54 0 .36.03.7.1 1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6 1.45-.6 2.3 0 1.56.8 2.95 2 3.77-.74-.03-1.44-.23-2.05-.57v.06c0 2.2 1.56 4.03 3.64 4.44-.67.2-1.37.2-2.06.08.58 1.8 2.26 3.12 4.25 3.16C5.78 18.1 3.37 18.74 1 18.46c2 1.3 4.4 2.04 6.97 2.04 8.35 0 12.92-6.92 12.92-12.93 0-.2 0-.4-.02-.6.9-.63 1.96-1.22 2.56-2.14z"
	    }
	  })])])])]), " ", " ", _h('a', {
	    staticClass: "resp-sharing-button__link",
	    attrs: {
	      "href": "mailto:?subject=Magna%20Mater&body=http%3A%2F%2Fadrienmenegaux.com%2F",
	      "target": "_self",
	      "aria-label": ""
	    }
	  }, [_h('div', {
	    staticClass: "resp-sharing-button resp-sharing-button--email resp-sharing-button--small"
	  }, [_h('div', {
	    staticClass: "resp-sharing-button__icon resp-sharing-button__icon--solid",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_h('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_h('path', {
	    attrs: {
	      "d": "M22 4H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.25 14.43l-3.5 2c-.08.05-.17.07-.25.07-.17 0-.34-.1-.43-.25-.14-.24-.06-.55.18-.68l3.5-2c.24-.14.55-.06.68.18.14.24.06.55-.18.68zm4.75.07c-.1 0-.2-.03-.27-.08l-8.5-5.5c-.23-.15-.3-.46-.15-.7.15-.22.46-.3.7-.14L12 13.4l8.23-5.32c.23-.15.54-.08.7.15.14.23.07.54-.16.7l-8.5 5.5c-.08.04-.17.07-.27.07zm8.93 1.75c-.1.16-.26.25-.43.25-.08 0-.17-.02-.25-.07l-3.5-2c-.24-.13-.32-.44-.18-.68s.44-.32.68-.18l3.5 2c.24.13.32.44.18.68z"
	    }
	  })])])])])]), " ", _h('div', {
	    staticClass: "testimonial-subtitle testimonial-subtitle-final"
	  }, ["Découvrir d'autres témoignages"])]), " ", _h('div', {
	    staticClass: "similars"
	  }, [_vm._l((_vm.similars), function(couple) {
	    return _h('router-link', {
	      staticClass: "link",
	      attrs: {
	        "to": '/testimonials/' + couple.slug
	      }
	    }, [_h('Card', {
	      staticClass: "couple",
	      attrs: {
	        "title": couple.name,
	        "subtitle": couple.location,
	        "img": couple.img
	      }
	    })])
	  })])])])
	},staticRenderFns: []}

/***/ },
/* 57 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return (_vm.$route.path !== '/experience') ? _h('nav', {
	    staticClass: "nav-bar"
	  }, [_h('router-link', {
	    staticClass: "link",
	    style: ({
	      color: _vm.$route.path === '/' ? 'white' : ''
	    }),
	    attrs: {
	      "to": "/"
	    }
	  }, ["Accueil"]), " ", _h('router-link', {
	    staticClass: "link",
	    style: ({
	      color: _vm.$route.path === '/' ? 'white' : ''
	    }),
	    attrs: {
	      "to": "/experience"
	    }
	  }, ["Expérience"]), " ", _h('router-link', {
	    staticClass: "link",
	    style: ({
	      color: _vm.$route.path === '/' ? 'white' : ''
	    }),
	    attrs: {
	      "to": "/testimonials"
	    }
	  }, ["Témoignages"]), " ", _h('router-link', {
	    staticClass: "link",
	    style: ({
	      color: _vm.$route.path === '/' ? 'white' : ''
	    }),
	    attrs: {
	      "to": "/credits"
	    }
	  }, ["Crédits"])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 58 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_h('NavBar'), " ", _h('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_h('router-view')])])
	},staticRenderFns: []}

/***/ },
/* 59 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "homepage"
	  }, [_vm._m(0), " ", _h('router-link', {
	    staticClass: "button",
	    attrs: {
	      "to": "/experience"
	    }
	  }, ["Incarner une mère"]), " ", _h('p', {
	    staticClass: "description"
	  }, ["Lors de cette expérience, vous allez vivre le rôle d'une mère.\n  "])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('h1', ["MAGNA", _h('br'), "MATER"])
	}]}

/***/ },
/* 60 */,
/* 61 */,
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./anne_isabelle_famille_homoparentale.jpg": 29,
		"./christina_karina_famille_homoparentale_suede.jpg": 30,
		"./emmet_gabriel_famille_homoparentale_usa.jpg": 31,
		"./homepage_cover.png": 32,
		"./john_anthony_famille_homoparentale_pays_bas.jpg": 33,
		"./lisa_melissa_famille_homoparentale_canada.jpg": 34,
		"./logo.png": 35,
		"./paul_henri.png": 36,
		"./tess_nikina_famille_homoparentale_canada.jpg": 37
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 62;


/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.a6f67b71402560d8e511.js